// Generated code, do not edit manually. Run the following command to regenerate it:
// > nx generate-icons packages/systems/wfdl-builtin-plugin

import {SVGProps, ReactElement, createElement} from 'react';
import type {IconProps} from '@packages/utilities/icon-support';
export default /*#__PURE__#*/ function Record(
  props: IconProps
): ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale =
    typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement(
    'svg',
    {
      'data-icon': 'Record',
      'aria-hidden': true,
      focusable: false,
      width: 12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {
        ...{
          display: 'block',
        },
        ...props.style,
      },
    },
    createElement(
      'g',
      {clipPath: 'url(#wf-svg-Record-__a)'},
      createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M5 0h-.033c-.35 0-.749 0-1.118.047-.39.05-.837.162-1.243.452C1.747 1.112 1.5 2.19 1.5 3.5 1.5 4.372.727 5 0 5v2c.727 0 1.5.628 1.5 1.5 0 1.31.247 2.388 1.106 3.001.406.29.853.402 1.243.452A9 9 0 0 0 4.967 12H5v-2c-.392 0-.668-.002-.896-.03-.22-.03-.303-.073-.335-.096C3.748 9.86 3.5 9.683 3.5 8.5A3.4 3.4 0 0 0 2.429 6 3.4 3.4 0 0 0 3.5 3.5c0-1.183.25-1.36.268-1.374.033-.023.116-.067.336-.095C4.332 2.001 4.608 2 5 2zm2 0h.033c.35 0 .749 0 1.118.047.39.05.837.162 1.243.452.859.613 1.106 1.692 1.106 3.001 0 .872.773 1.5 1.5 1.5v2c-.727 0-1.5.628-1.5 1.5 0 1.31-.247 2.388-1.106 3.001-.406.29-.853.402-1.243.452A9 9 0 0 1 7.033 12H7v-2c.392 0 .668-.002.896-.03.22-.03.303-.073.335-.096.02-.014.269-.191.269-1.374A3.4 3.4 0 0 1 9.571 6 3.4 3.4 0 0 1 8.5 3.5c0-1.183-.25-1.36-.268-1.374-.033-.023-.116-.067-.336-.095C7.668 2.001 7.392 2 7 2z',
        fill: 'currentColor',
      })
    ),
    createElement(
      'defs',
      null,
      createElement(
        'clipPath',
        {id: 'wf-svg-Record-__a'},
        createElement('path', {fill: '#fff', d: 'M0 0h12v12H0z'})
      )
    )
  );
}
